/**
 * Conver 24hrs string format to datetime
 * @param {any}  24hrs format e.g '15:00'
 */
const ParseTimeString = function (time24h) {
    const splitted = time24h.split(':');
    const dateTime = new Date();
    dateTime.setHours(splitted[0]);
    dateTime.setMinutes(splitted[1]);

    return dateTime;
};
export default ParseTimeString;
